<dx-data-grid [dataSource]="_dataSource"
              [columns]="_columns"
              [summary]="_summary"
              (onInitialized)="_onInitialized($event)"
              (onContentReady)="_onContentReady($event)"
              (onRowClick)="onRowClick.emit($event)"
              (onSelectionChanged)="onSelectionChanged.emit($event)"
              [searchPanel]="_searchPanel"
              [selection]="_selection"
              [paging]="_paging"
              [scrolling]="_scrolling"
              [columnAutoWidth]="_columnAutoWidth"
              [height]="_height"
              [hoverStateEnabled]="_hoverStateEnabled"
              [export]="_export"
              [width]="_width">
  <div *dxTemplate="let c of 'bookmarkCellTemplate'">
    <dx-button icon="bookmark" stylingMode="text" (onClick)="_onBookmarkClick($event, c.data)"></dx-button>
  </div>
  <dxo-header-filter [visible]="showHeaderFilter"></dxo-header-filter>
  <dxo-group-panel [visible]="showGroupPanel"></dxo-group-panel>
</dx-data-grid>
